import { useEffect, useState } from 'react';
import { api, darf, type Anmelder } from '../api.ts';
import {
  Dialog, Fehlerkasten, Text, ausFehler, type Fehlerlage,
} from './Formular.tsx';
import { Leer } from './Geruest.tsx';
import { useFrisch } from './Frisch.tsx';

/**
 * Orte, in denen wir nicht arbeiten - die Liste, in den EINSTELLUNGEN.
 *
 * ORIGINALTEXT MARVIN (08.09.2026)
 *   „wo ist denn jetzt die liste um die orte, die uns nicht betreffen zu
 *    sperren, damit sie nirgendswo auftauchen im system und direkt immer
 *    rausgefiltert werden überall!"
 *   „derpunkt soll in die einstellungen"
 *
 * **DAS WAR DIE VIERTE FRAGE NACH DERSELBEN LISTE** (02.09., 03.09., 07.09.,
 * 08.09.). Es gab sie jedes Mal, und jedes Mal an einer Stelle, die nicht so
 * hiess: unter „Stammdaten → Ort und Gemeinde", hinter einem Knopf „Ort
 * zuordnen", mit einem Haken, der „für diesen Ort ist ausdrücklich keine
 * Gemeinde zuständig" hiess.
 *
 * DER TEUERSTE TEIL DAVON WAR EIN ZIRKEL: die Karte mit der Liste erschien
 * erst, wenn schon ein Ort gesperrt war (`gefiltert.length > 0`). Bei Marvin
 * standen 0 von 23 - **um die Liste zu sehen, musste schon etwas darin
 * stehen.** Dieselbe Bauart wie bei den Ordnern eines Abschnitts, die man
 * erst füllen musste, um sie anzulegen (05.09.2026).
 *
 * SIE STEHT DESHALB IMMER DA, auch leer, und sie sagt dann, wofür sie da ist.
 * Das ist kein Verstoss gegen „eine Karte, die immer null zeigt, steht gar
 * nicht erst da": diese Karte ist das WERKZEUG und kein Befund - wer sperren
 * will, sucht sie genau dann, wenn nichts darin steht. Dieselbe Ausnahme wie
 * bei „Die Ablage nachsehen" im Systemzustand.
 *
 * UND SIE STEHT NUR HIER. In den Stammdaten ist sie weggefallen; zwei Wege zu
 * derselben Sache sind kein doppelter Komfort, sondern eine halbe Auskunft.
 * Was dort BLEIBT, ist die Gemeindezuordnung - das ist eine andere Frage
 * (welche Behörde bekommt die Post) und war nur zufällig in derselben Karte.
 */
export function Ortssperre({ ich }: { ich: Anmelder }) {
  const [d, setD] = useState<any>(null);
  const [neu, setNeu] = useState<string | null>(null);
  const [probe, setProbe] = useState<any>(null);
  const [laeuft, setLaeuft] = useState(false);
  const [meldung, setMeldung] = useState<string | null>(null);
  const [fehler, setFehler] = useState<Fehlerlage | null>(null);
  const darfPflegen = darf(ich, 'stammdaten.pflegen');

  async function laden() {
    try { setD(await api.ortszuordnung()); }
    catch (f) { setFehler(ausFehler(f)); }
  }
  useEffect(() => { laden(); }, []);
  useFrisch(laden);

  const gesperrt = (d?.zeilen ?? []).filter((o: any) => o.ignoriert);

  /* DIE PROBE LÄUFT BEIM TIPPEN UND NICHT ERST BEIM SPEICHERN. Wer den Namen
     eingetippt hat, will sehen, was er auslöst - danach zu fragen wäre eine
     Rückfrage, und eine Rückfrage, die immer gleich beantwortet wird, ist
     keine Sicherung, sondern eine Gewöhnung. */
  async function pruefen(ort: string) {
    if (!ort.trim()) { setProbe(null); return; }
    try { setProbe(await api.ortSperrprobe(ort.trim())); }
    catch { setProbe(null); }
  }

  async function sperren() {
    if (!neu?.trim()) return;
    setLaeuft(true); setFehler(null);
    try {
      await api.ortSetzen({ name: neu.trim(), ignoriert: true });
      /* SIE WIRKT SOFORT UND NICHT ERST ÜBER NACHT. Der Lauf, der archiviert,
         steht direkt daneben - sonst läge zwischen dem Haken und seiner
         Wirkung eine Nacht, und in dieser Nacht steht der Ort weiter in jeder
         Liste. Genau das war die Beanstandung. */
      const r = await api.ortszuordnungAnwenden(false);
      setMeldung(r?.meldung ?? 'Der Ort ist gesperrt.');
      setNeu(null); setProbe(null);
      await laden();
    } catch (f) { setFehler(ausFehler(f)); }
    finally { setLaeuft(false); }
  }

  async function freigeben(name: string) {
    setLaeuft(true); setFehler(null);
    try {
      const r = await api.ortSetzen({ name, ignoriert: false });
      setMeldung(r?.meldung
        ?? `„${name}" ist wieder frei.`);
      await laden();
    } catch (f) { setFehler(ausFehler(f)); }
    finally { setLaeuft(false); }
  }

  return (
    <div style={{ marginTop: 14 }}>
      <Fehlerkasten lage={fehler} />
      {meldung && <div className="hinweis">{meldung}</div>}

      <p className="klein leise" style={{ marginTop: 0 }}>
        Aus diesen Orten liest der Import <b>keine Zeile</b> mehr ein, und was
        schon dasteht, wird archiviert - <b>auch dann, wenn Termine oder
        Aufmaßzeilen daran hängen</b>. Sie fallen damit aus jeder Liste: der
        Arbeitsliste, dem Terminplaner, der Auswertung, der Kapazität.
        Es ist umkehrbar: wer einen Ort wieder freigibt, bekommt genau die
        Aufträge zurück, die wegen dieses Ortes gegangen sind.
      </p>

      {!gesperrt.length ? (
        <Leer text="Noch kein Ort gesperrt. Hier stehen die Orte, in denen wir
                    nicht arbeiten - die Telekom liefert regelmäßig
                    Anschriften aus Gebieten, die uns nicht betreffen." />
      ) : (
        <table className="liste">
          <thead>
            <tr>
              <th>Ort</th>
              <th style={{ width: 120 }} className="zahl">Adressen</th>
              <th style={{ width: 150 }}></th>
            </tr>
          </thead>
          <tbody>
            {gesperrt.map((o: any) => (
              <tr key={o.name} style={{ cursor: 'default' }}>
                <td data-spalte="Ort">{o.name}</td>
                <td data-spalte="Adressen" className="zahl">{o.adressen}</td>
                <td className="knopfleiste">
                  {darfPflegen && (
                    <button className="knopf klein" disabled={laeuft}
                            onClick={() => freigeben(o.name)}>
                      Wieder freigeben
                    </button>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}

      {darfPflegen && (
        <div className="reihe" style={{ marginTop: 10 }}>
          <button className="knopf" onClick={() => { setNeu(''); setProbe(null); }}>
            Ort sperren
          </button>
        </div>
      )}

      {neu !== null && (
        <Dialog titel="Einen Ort sperren" breite={560} laeuft={laeuft}
                zu={() => { setNeu(null); setProbe(null); }}>
          <Fehlerkasten lage={fehler} />
          <Text name="ort" titel="Ort" pflicht breite="100%"
                wert={neu} fehler={fehler}
                setze={(w: string) => { setNeu(w); pruefen(w); }} />

          {/* WAS DAS KOSTET, STEHT VOR DEM KLICK UND NICHT DANACH.
              Ein Eingriff, der Aufträge mit Terminen archiviert, wird nicht
              blind gemacht. */}
          {probe && (
            <div className={'hinweis ' + (probe.mitArbeit ? 'warnung' : '')}>
              <b>
                {probe.auftraege === 0
                  ? 'Kein Auftrag steht heute in diesem Ort.'
                  : `${probe.auftraege} Aufträge stehen in diesem Ort und `
                    + 'werden archiviert.'}
              </b>
              {probe.mitArbeit > 0 && (
                <div className="klein" style={{ fontWeight: 400, marginTop: 4 }}>
                  An <b>{probe.mitArbeit}</b> davon hängt Arbeit: Termine,
                  Aufmaßzeilen, Dateien oder Papiere. Sie gehen mit - und
                  kommen zurück, sobald der Ort wieder frei ist.
                </div>
              )}
              {!!probe.beispiele?.length && (
                <div className="klein leise" style={{ marginTop: 4 }}>
                  {probe.beispiele.slice(0, 6)
                    .map((z: any) => z.anschrift
                                     + (z.kls_id ? ` (${z.kls_id})` : ''))
                    .join(', ')}
                  {probe.auftraege > 6 ? ' …' : ''}
                </div>
              )}
            </div>
          )}

          <p className="klein leise">
            Ob in einem Ort gearbeitet wird, weiß dieses System nicht. Der
            Handgriff bleibt deiner: wer ihn rät, lässt Aufträge verschwinden,
            auf die jemand wartet.
          </p>

          <div className="reihe" style={{ marginTop: 12 }}>
            <button className="knopf haupt warnung"
                    disabled={laeuft || !neu.trim()} onClick={sperren}>
              {laeuft ? 'Einen Moment' : 'Sperren und archivieren'}
            </button>
            <button className="knopf" disabled={laeuft}
                    onClick={() => { setNeu(null); setProbe(null); }}>
              Abbrechen
            </button>
          </div>
        </Dialog>
      )}
    </div>
  );
}
